import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { useFormik } from 'formik';

import DatePicker from '../../../common/DatePicker';
import Button from '../../../common/Button';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .finance-table__top-wrap {
    justify-content: space-between;
    align-items: flex-end;
  }
  .finance-table__dates-block {
    display: flex;
    max-width: 334px;
    width: 100%;
    margin: 0 -5px;
  }
  .finance-table__dates-elem {
    margin: 0 5px;
    position: relative;
  }
  .btn {
    height: 34px;
  }
  label {
    color: #343a40;
  }
  .finance-table__top-block {
  }
  .finance-table__types {
    max-width: 228px;
    width: 100%;
    margin-left: 6px;
  }

  .finance-table__top {
    margin-bottom: 24px;
  }

  .react-datepicker {
    border-color: #ced4da;
    font-family: inherit;
    color: #323a46;

    &__header {
      background: #f1f5f7;
      border-color: #ced4da;
    }

    &__day {
      color: inherit;
    }

    &__day-name {
      color: inherit;
    }

    &__day--keyboard-selected {
      color: white;
    }

    &__day--selected {
      color: white;
      background-color: #7e57c2;
    }

    &__current-month {
      color: inherit;
    }

    &__day--disabled {
      color: #ccc;
    }
  }

  @media (max-width: 649px) {
    .finance-table__types {
      margin-left: 0;
      margin-top: 10px;
      max-width: 100%;
    }
  }
  @media (max-width: 540px) {
    .finance-table__dates-block {
      flex-wrap: wrap;
      margin: 0;
    }
    .finance-table__dates-elem {
      width: 100%;
      margin: 0 0 5px 0;
      .react-datepicker-wrapper {
        width: 100%;
      }
    }
  }
`;

const FilterBlock = (props) => {
  const { handleExportModal, dateTo, setDateTo, dateFrom, setDateFrom } = props;
  const { t } = useAutoTranslation();
  return (
    <>
      <Wrapper>
        <div className="finance-table__top">
          <div className="row finance-table__top-wrap">
            <div className="col-md-9 d-flex flex-md-nowrap flex-wrap mb-md-0 mb-2">
              <div className="finance-table__top-block">
                <label>{t('Период')}</label>
                <div className="finance-table__dates-block">
                  <div className="finance-table__dates-elem">
                    <DatePicker
                      placeholderText={t('Начало периода')}
                      selected={
                        dateFrom
                          ? moment(dateFrom, 'YYYY-MM-DD')
                              .set('hour', 23)
                              .set('minute', 59)
                              .set('second', 59)
                              .toDate()
                          : null
                      }
                      onChange={(date) =>
                        setDateFrom(
                          moment(date)
                            .set('hour', 0)
                            .set('minute', 0)
                            .set('second', 0)
                            .format(`YYYY-MM-DDTHH:mm:ss`),
                        )
                      }
                      maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                      icon={true}
                    />
                  </div>
                  <div className="finance-table__dates-elem">
                    <DatePicker
                      placeholderText={t('Конец периода')}
                      selected={
                        dateTo
                          ? moment(dateTo, 'YYYY-MM-DD')
                              .set('hour', 23)
                              .set('minute', 59)
                              .set('second', 59)
                              .toDate()
                          : null
                      }
                      minDate={dateFrom ? moment(dateFrom, 'YYYY-MM-DD').toDate() : null}
                      maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                      onChange={(date) =>
                        setDateTo(
                          moment(date)
                            .set('hour', 23)
                            .set('minute', 59)
                            .set('second', 59)
                            .format(`YYYY-MM-DDTHH:mm:ss`),
                        )
                      }
                      icon={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-4 d-flex justify-content-md-end">
              {/*<Button*/}
              {/*  classType="btn-light"*/}
              {/*  icon="fe-arrow-down"*/}
              {/*  text="Экспорт"*/}
              {/*  onClick={() => handleExportModal()}*/}
              {/*></Button>*/}
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default FilterBlock;
